import React from 'react'
import { useQuery } from '@apollo/client'
import { QUERY } from '../../apollo'
import { ItemsList } from './Navigation'

import styles from './detail.module.css'

function ProfileHome() {
  const { data } = useQuery(QUERY.USER_INFO)
  const userInfo = data?.userInfo
  return userInfo ? (
    <div className={styles.wrapper}>
      <img
        alt="Pixden Music"
        src={require(`../../images/walkman_transp.png`)}
        className={styles.walkmanImage}
      />
      <div className={styles.content}>
        <p className={styles.pageTitle}>
          Welcome {userInfo.name} to your Profile.
        </p>
        <h2 className={styles.mainHeading} style={{ marginBottom: '.3em' }}>
          Quote
        </h2>
        <ItemsList
          kind="quote"
          items={userInfo.quote}
          linkText={({ projectName, date }) => (
            <>
              {projectName}
              <br />
              <small>{date}</small>
            </>
          )}
        />

        <h2
          className={styles.mainHeading}
          style={{ marginTop: '2em', marginBottom: '.3em' }}
        >
          Supervision
        </h2>
        <ItemsList
          kind="supervision"
          items={userInfo.supervision}
          linkText={({ licenseUser, media, date }) =>
            `${licenseUser} ${media} ${date}`
          }
        />

        <h2
          className={styles.mainHeading}
          style={{ marginTop: '2em', marginBottom: '.3em' }}
        >
          Purchased
        </h2>
        <ItemsList
          kind="purchased"
          items={userInfo.purchased}
          linkText={({ trackName, trackArtist }) => (
            <>
              {trackName}
              <br />
              <small>{trackArtist}</small>
            </>
          )}
        />
      </div>
    </div>
  ) : null
}

export default ProfileHome
